import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { Form, Formik } from 'formik';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { DescargarReportesCampos } from './DescargarReportesCampos';
import { useDescargarReporte } from './useDescargarReporte';
import { INIT_DATA } from './helpers/Texts';
import { descargarReporteSchema } from './helpers/descargarReporteSchema';
import { DescargarReportesSkeleton } from './helpers/DescargarReportesSkeleton';

export const DescargarReportes = () => {
  const {
    desplegarComponente,
    isCargandoConfiguracion,
    grupos,
    negocios,
    sucursales,
    recargarSucursales,
    handleSubmit,
    recargarNegocios
  } = useDescargarReporte();

  if (isCargandoConfiguracion) {
    return <DescargarReportesSkeleton />;
  }

  return (
    <SidebarLayout>
      <div className="flex items-center mb-4">
        <div>
          <Heading type="h2" className="mb-0">
            Reportes
          </Heading>
          <Text className="mb-4">
            Genera reportes según los filtros que tu definas basados en los
            datos ingresados en la plataforma.
          </Text>
        </div>
      </div>

      <Formik
        initialValues={{
          tipo: 'personalizado',
          ...INIT_DATA
        }}
        validationSchema={descargarReporteSchema}
        validateOnChange={true}
        validateOnBlur={true}
        validateOnMount={true}
        onSubmit={async (values, { resetForm, setSubmitting }) => {
          try {
            setSubmitting(true);
            await handleSubmit(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {props => (
          <Form id="descargarReporte">
            <div className="bg-white rounded shadow-md mb-5">
              <DescargarReportesCampos
                handleChange={props.handleChange}
                values={props.values}
                errors={props.errors}
                touched={props.touched}
                desplegarComponente={desplegarComponente}
                setValues={props.setValues}
                setFieldValue={props.setFieldValue}
                grupos={grupos}
                negocios={negocios}
                sucursales={sucursales}
                recargarSucursales={recargarSucursales}
                isSubmitting={props.isSubmitting}
                recargarNegocios={recargarNegocios}
              />
            </div>
          </Form>
        )}
      </Formik>
    </SidebarLayout>
  );
};
